export const SET_USER = "set_user";
export const IS_LOGGED = "is_logged";
